import { LeadResponse } from '../services/responses/lead.response';

/// O fechado manda quando existe: a estimativa já cumpriu o papel.
export const leadAmount = (lead: LeadResponse): number | null | undefined => lead.closedValue ?? lead.value;

/// Sem centavos: no quadro e na lista o que importa é a ordem de grandeza.
export const formatRoundedBrl = (value: number): string =>
    value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
